const cumulativeOffset = (element) => {
  let top = 0;
  let left = 0;
  do {
      top += element.offsetTop  || 0;
      left += element.offsetLeft || 0;
      element = element.offsetParent;
  } while(element);

  return {
    top: top,
    left: left,
  };
};

const isElementContained = (element, ancestorSelector) => {
  const ancestor = document.querySelector(ancestorSelector);
  if (!ancestor) {
    return false;
  }
  return ancestor.contains(element);
};

const getElementLink = (element) => {
  let isLink = element.nodeName === 'A';
  if (isLink) {
    return element;
  }
  const wrapper = element.closest('a');
  return wrapper;
}

export {
  cumulativeOffset,
  getElementLink,
  isElementContained,
};
